import store from "../redux/store";
import { handleJoiSchemaError } from "../utils";
import { logMediumError } from "../utils/logger";
import { API_DEVICE_USED_PROMO_CODE } from "./api";
import { sendDeleteRequest } from "./backend";

export const deleteDeviceUsedPromotion = async (
  deviceId: string,
  promoCodeKey: string
): Promise<boolean> => {
  const { companyId } = store.getState().configurationReducer;
  try {
    await sendDeleteRequest(
      API_DEVICE_USED_PROMO_CODE(companyId, deviceId, promoCodeKey)
    );
    return true;
  } catch (error) {
    logMediumError(
      `Failed to delete promo code (${promoCodeKey}) from device (${deviceId}) on company (${companyId}) ${handleJoiSchemaError(
        error
      )}`,
      { deviceId, promoCodeKey }
    );

    return false;
  }
};
